<template>
  <div class="p-recruit">
    <div class="p-recruit__wrap">
      <h1>RECRUIT</h1>
      
      <div class="c-employee" v-for="item in baseRecruit.employee">
        <h3>{{item.title}}</h3>
        <ul>
          <li v-for="list in item.summary">
            <span>{{list.label}}</span>
            <p v-html="list.text"></p>
          </li>
        </ul>
      </div>
      
      <div class="c-summary">
        <h3>※各募集職種の共通事項</h3>
        <ul>
          <li v-for="item in baseRecruit.base">
            <span>{{item.label}}</span>
            <p v-html="item.text"></p>
          </li>
        </ul>
      </div>

      <ul class="c-contactList">
        <li>
          <span>Mail:</span>
          <a :href="`mailto:${baseRecruit.recruit_mail}`">{{baseRecruit.recruit_mail}}</a>
        </li>
      </ul>

      <address class="c-address">
        {{baseAbout.company}}<br />
        〒{{baseAbout.postcode}} {{baseAbout.address}}
      </address>

      <a class="c-btnMap" :href="baseAbout.googlemap_url" target="_blank" rel="noopener">
        <span class="c-btnMap__text">Google Map</span>
        <span class="c-btnMap__arrow"></span>
      </a>
    </div>
  </div>
</template>

<script>
  import {breakpoint, assets_path} from '@/_constant/variables';
  import store from '@/_modules/stores';
  import PerfectScrollbar from 'perfect-scrollbar';
  import {gsap, Cubic} from 'gsap';
  import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
  gsap.registerPlugin(ScrollToPlugin);

  export default {
    components: {
    },
    data() {
      return {
        breakpoint: breakpoint,
        assets_path: assets_path,
        baseAbout: {},
        baseRecruit: {},
        ps: null,
      }
    },
    store,
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.params = to.params;
        vm.from = from;
      });
    },
    beforeRouteUpdate(to, from, next) {
      // 削除
      this.destroy();
      // 次へ
      this.params = to.params;
      this.from = from;
      this.$nextTick(this.init);
      next();
    },
    beforeRouteLeave (to, from, next) {
      this.destroy();
      next();
    },
    computed: {
    },
    mounted() {
      this.$store.commit('setContainerClass', 'c-slanted--recruit');
      this.$store.commit('setTop', false);
      this.$nextTick(this.init);
    },
    methods: {
      init() {
        this.baseAbout = this.$siteData.about;
        this.baseRecruit = this.$siteData.recruit;
        this.$nextTick(this.initScrollbar);
      },
      initScrollbar() {
        if (gSLANTED.isDevice === 'pc') {
          // perfect scrollbar
          const baseScrollConfig = {
            wheelSpeed: 1,
            wheelPropagation: true,
            minScrollbarLength: 10,
            suppressScrollX: true
          };

          this.ps = new PerfectScrollbar(
            this.$el,
            baseScrollConfig
          );
        }
        //this.$el.scrollTop = 0;
      },
      destroy() {
        if (this.ps) {
          this.ps.destroy();
          this.ps = null;
        }
      },
    }
  }
</script>